import { apiService } from '@shared/services/apiServices';
import { AxiosError } from 'axios';
import plLabels from '../constants/plLabels.json';
import employeeEndpoints from './employeeEndpoints';

const GENERIC_ERROR = plLabels.common.genericError;

export interface UpdateEmployeeStatusResult {
  success: boolean;
  error?: string;
  isConflict?: boolean;
}

const resolveError = (
  isActive: boolean,
  statusCode: number | undefined
): string => {
  switch (statusCode) {
    case 401:
      return 'Twoja sesja wygasła. Zaloguj się ponownie.';
    case 403:
      return 'Nie masz uprawnień do wykonania tej czynności.';
    case 404:
      return 'Nie znaleziono pracownika.';
    case 409:
      return isActive
        ? 'Pracownik jest już aktywny.'
        : 'Pracownik jest już dezaktywowany.';
    default:
      return GENERIC_ERROR;
  }
};

export const updateEmployeeStatusApiService = {
  updateEmployeeStatus: async (params: {
    employeeId: string;
    isActive: boolean;
  }): Promise<UpdateEmployeeStatusResult> => {
    try {
      const result = await apiService.patchAPI(
        employeeEndpoints.EMPLOYEE_STATUS(params.employeeId),
        { isActive: params.isActive }
      );

      if (!result.error || result.status === 204) {
        return { success: true };
      }

      return {
        success: false,
        error: resolveError(params.isActive, result.status),
        isConflict: result.status === 409,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        return {
          success: false,
          error: resolveError(params.isActive, error.response?.status),
          isConflict: error.response?.status === 409,
        };
      }
      return { success: false, error: GENERIC_ERROR };
    }
  },
};
